<template>
  <!-- On iOS without push support, popup auto-closes in created() — renders nothing -->
  <LLConfirmModalTransition v-if="showContent" appear>
    <LLConfirmModal>
      <!-- Normal flow: explain + request permission -->
      <div class="notification-introduction-popup">
        <h2>
          {{ $t('popups.notification-introduction.title') }}
        </h2>
        <ImageLoaderImage
          class="notification-introduction-popup__image"
          src="/images/popups/notification-introduction/header.png"
        />
        <p>
          {{ $t('popups.notification-introduction.description_1') }}
        </p>
        <p>
          {{ $t('popups.notification-introduction.description_2') }}
        </p>
        <p>{{ $t('popups.notification-introduction.description_3') }}</p>

        <div class="notification-introduction-popup__actions">
          <LLButton class="notification-introduction-popup__button" @click="onClose">
            {{ $t('popups.notification-introduction.button') || 'Got it, thanks!' }}
          </LLButton>
        </div>
      </div>
    </LLConfirmModal>
  </LLConfirmModalTransition>
</template>

<script>
import LLConfirmModal from '@/components/common/LLConfirmModal.vue'
import LLConfirmModalTransition from '@/components/common/LLConfirmModal/LLConfirmModalTransition.vue'
import LLButton from '@/components/common/ui-components/LLButton.vue'
import ImageLoaderImage from '@/components/common/ImageLoader/ImageLoaderImage.vue'
import { getIOSPushStatus } from '@/utils/pushNotifications'

export default {
  name: 'NotificationIntroductionPopup',
  components: { ImageLoaderImage, LLButton, LLConfirmModalTransition, LLConfirmModal },
  data() {
    return {
      showContent: true
    }
  },
  created() {
    // On iOS without push support, silently close — no point asking
    const iosStatus = getIOSPushStatus()
    if (iosStatus === 'not-standalone' || iosStatus === 'too-old') {
      this.showContent = false
      this.$emit('close')
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.notification-introduction-popup {
  @screen md {
    width: 530px;
    max-width: 100%;
  }
  h2 {
    @apply text-center;
  }
  &__image {
    @apply my-6 mx-auto;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 400px;
  }
  p {
    @apply my-5;
  }
  &__actions {
    @apply flex justify-end gap-2;
  }
  &__button {
    float: right;
    &:last-child {
      float: none;
    }
  }
  &__denied {
    @apply text-accent-01 text-center my-4;
  }
}
</style>
